import { useState } from "react";

const DelegateProductReadOnlyRow = ({ index, t, delegateItem, handleDeleteClick, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, delegateItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, delegateItem, submitComplete);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td-sm col text-wrap odd" : "list-td-sm col text-wrap even"}>{delegateItem.companyName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{delegateItem.productName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{delegateItem.productSku}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{delegateItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, delegateItem)}>
					{delegateItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>


		</tr>
	)
}
export default DelegateProductReadOnlyRow;